import { createFileRoute, redirect } from '@tanstack/react-router'
import { SUBSCRIPTION_SHORTCUT_ROUTES, SubscriptionShortcutPath } from 'appRoutes'
import { SubscriptionShortcutRedirect } from 'features/subscription'

const set = new Set(SUBSCRIPTION_SHORTCUT_ROUTES)

export const Route = createFileRoute('/_authenticated/_layout/$')({
  component: Page,
  beforeLoad: ({ location }) => {
    if (!set.has(location.pathname)) {
      throw redirect({ to: '/', replace: true })
    }
  },
})

function Page() {
  const { _splat } = Route.useParams()
  return <SubscriptionShortcutRedirect pathname={(_splat ?? '') as SubscriptionShortcutPath} />
}
